module.exports = __webpack_public_path__ + "img/icon_question.57f30044.png";